import { commentItems } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            用户口碑
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            听听成全影院的用户怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {commentItems.map((comment) => (
            <div
              key={comment.id}
              className="flex flex-col p-5 md:p-6 rounded-lg bg-background-100 border border-background-200"
            >
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: comment.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm text-accent-400"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4 flex-1">
                &ldquo;{comment.content}&rdquo;
              </p>
              <div className="text-xs text-foreground-500 mb-3">
                看过 {comment.watched}
              </div>
              <div className="flex items-center gap-3 pt-3 border-t border-background-200">
                <img
                  src={comment.avatar}
                  alt={comment.author}
                  className="w-9 h-9 rounded-full object-cover"
                  loading="lazy"
                  onError={(e) => { const t = e.currentTarget; t.style.display = 'none'; }}
                />
                <div>
                  <div className="text-sm font-medium text-foreground-800">
                    {comment.author}
                  </div>
                  <div className="text-xs text-foreground-500">
                    {comment.date}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}